var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { styleMap } from 'lit-html/directives/style-map.js';
import { property, queryAssignedElements } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './sds-toolbar.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * Control that represents toolbar.
 *
 * @slot icon - This slot is the container for the toolbar icon
 * @slot search - This slot is the container for the toolbar search
 * @slot title - This slot is the container for the toolbar title
 * @slot content - This slot is the container for the toolbar content
 * @slot actions - This slot is the container for the toolbar actions
 */
let SdsToolbar = (() => {
    var _SdsToolbar_withoutBorder_accessor_storage, _SdsToolbar_toolbarSearch_accessor_storage, _SdsToolbar_toolbarTitle_accessor_storage, _SdsToolbar_content_accessor_storage, _SdsToolbar_actions_accessor_storage, _SdsToolbar_toggle_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-toolbar')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _withoutBorder_decorators;
    let _withoutBorder_initializers = [];
    let _withoutBorder_extraInitializers = [];
    let _toolbarSearch_decorators;
    let _toolbarSearch_initializers = [];
    let _toolbarSearch_extraInitializers = [];
    let _toolbarTitle_decorators;
    let _toolbarTitle_initializers = [];
    let _toolbarTitle_extraInitializers = [];
    let _content_decorators;
    let _content_initializers = [];
    let _content_extraInitializers = [];
    let _actions_decorators;
    let _actions_initializers = [];
    let _actions_extraInitializers = [];
    let _toggle_decorators;
    let _toggle_initializers = [];
    let _toggle_extraInitializers = [];
    var SdsToolbar = _classThis = class extends _classSuper {
        /**
         * True if toolbar does not have border
         * @attr
         */
        get withoutBorder() { return __classPrivateFieldGet(this, _SdsToolbar_withoutBorder_accessor_storage, "f"); }
        set withoutBorder(value) { __classPrivateFieldSet(this, _SdsToolbar_withoutBorder_accessor_storage, value, "f"); }
        get toolbarSearch() { return __classPrivateFieldGet(this, _SdsToolbar_toolbarSearch_accessor_storage, "f"); }
        set toolbarSearch(value) { __classPrivateFieldSet(this, _SdsToolbar_toolbarSearch_accessor_storage, value, "f"); }
        get toolbarTitle() { return __classPrivateFieldGet(this, _SdsToolbar_toolbarTitle_accessor_storage, "f"); }
        set toolbarTitle(value) { __classPrivateFieldSet(this, _SdsToolbar_toolbarTitle_accessor_storage, value, "f"); }
        get content() { return __classPrivateFieldGet(this, _SdsToolbar_content_accessor_storage, "f"); }
        set content(value) { __classPrivateFieldSet(this, _SdsToolbar_content_accessor_storage, value, "f"); }
        get actions() { return __classPrivateFieldGet(this, _SdsToolbar_actions_accessor_storage, "f"); }
        set actions(value) { __classPrivateFieldSet(this, _SdsToolbar_actions_accessor_storage, value, "f"); }
        get toggle() { return __classPrivateFieldGet(this, _SdsToolbar_toggle_accessor_storage, "f"); }
        set toggle(value) { __classPrivateFieldSet(this, _SdsToolbar_toggle_accessor_storage, value, "f"); }
        render() {
            return html `
            <div class="${this.getClasses()}" part="sds-toolbar">
                <div class="sds-toolbar__section">
                    ${this.renderExpandAction()}

                    <slot name="icon"></slot>

                    <div
                        class="sds-toolbar__title"
                        style="${this.getStyle(this.toolbarTitle, 'block')}"
                    >
                        <slot name="title" @slotchange="${() => this.requestUpdate()}"></slot>
                    </div>
                    <slot name="search"></slot>
                    <div
                        class="sds-toolbar__content"
                        style="${this.getStyle(this.content, 'flex')}"
                    >
                        <slot name="content" @slotchange="${() => this.requestUpdate()}"></slot>
                    </div>

                    <slot name="container"></slot>
                </div>
                <div class="sds-toolbar__section" style="${this.getStyle(this.actions, 'flex')}">
                    <slot name="actions" @slotchange="${() => this.requestUpdate()}"></slot>
                </div>
            </div>
        `;
        }
        renderExpandAction() {
            if (this.toggle === 'collapsed' || this.toggle === 'expanded') {
                return html `
                <sds-button
                    @click="${() => this.handleClick()}"
                    icon="${this.toggle === 'collapsed' ? 'arrow_right_thin' : 'arrow_down_thin'}"
                    type="secondary"
                    size="sm"
                ></sds-button>
            `;
            }
        }
        handleClick() {
            this.toggle = this.toggle === 'expanded' ? 'collapsed' : 'expanded';
            this.dispatchEvent(new CustomEvent(SdsToolbar.CARD_COLLAPSED_EVENT, {
                detail: {
                    toggle: this.toggle,
                },
            }));
        }
        getClasses() {
            return classMap({
                'sds-toolbar': true,
                'sds-toolbar--without-border': this.withoutBorder,
            });
        }
        getStyle(el, style) {
            return styleMap({ display: el.length > 0 ? style : 'contents' });
        }
        constructor() {
            super(...arguments);
            _SdsToolbar_withoutBorder_accessor_storage.set(this, __runInitializers(this, _withoutBorder_initializers, false));
            _SdsToolbar_toolbarSearch_accessor_storage.set(this, (__runInitializers(this, _withoutBorder_extraInitializers), __runInitializers(this, _toolbarSearch_initializers, void 0)));
            _SdsToolbar_toolbarTitle_accessor_storage.set(this, (__runInitializers(this, _toolbarSearch_extraInitializers), __runInitializers(this, _toolbarTitle_initializers, void 0)));
            _SdsToolbar_content_accessor_storage.set(this, (__runInitializers(this, _toolbarTitle_extraInitializers), __runInitializers(this, _content_initializers, void 0)));
            _SdsToolbar_actions_accessor_storage.set(this, (__runInitializers(this, _content_extraInitializers), __runInitializers(this, _actions_initializers, void 0)));
            _SdsToolbar_toggle_accessor_storage.set(this, (__runInitializers(this, _actions_extraInitializers), __runInitializers(this, _toggle_initializers, void 0)));
            __runInitializers(this, _toggle_extraInitializers);
        }
    };
    _SdsToolbar_withoutBorder_accessor_storage = new WeakMap();
    _SdsToolbar_toolbarSearch_accessor_storage = new WeakMap();
    _SdsToolbar_toolbarTitle_accessor_storage = new WeakMap();
    _SdsToolbar_content_accessor_storage = new WeakMap();
    _SdsToolbar_actions_accessor_storage = new WeakMap();
    _SdsToolbar_toggle_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsToolbar");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _withoutBorder_decorators = [property({ type: Boolean, attribute: 'without-border' })];
        _toolbarSearch_decorators = [queryAssignedElements({ slot: 'search' })];
        _toolbarTitle_decorators = [queryAssignedElements({ slot: 'title' })];
        _content_decorators = [queryAssignedElements({ slot: 'content' })];
        _actions_decorators = [queryAssignedElements({ slot: 'actions' })];
        _toggle_decorators = [property({ type: String })];
        __esDecorate(_classThis, null, _withoutBorder_decorators, { kind: "accessor", name: "withoutBorder", static: false, private: false, access: { has: obj => "withoutBorder" in obj, get: obj => obj.withoutBorder, set: (obj, value) => { obj.withoutBorder = value; } }, metadata: _metadata }, _withoutBorder_initializers, _withoutBorder_extraInitializers);
        __esDecorate(_classThis, null, _toolbarSearch_decorators, { kind: "accessor", name: "toolbarSearch", static: false, private: false, access: { has: obj => "toolbarSearch" in obj, get: obj => obj.toolbarSearch, set: (obj, value) => { obj.toolbarSearch = value; } }, metadata: _metadata }, _toolbarSearch_initializers, _toolbarSearch_extraInitializers);
        __esDecorate(_classThis, null, _toolbarTitle_decorators, { kind: "accessor", name: "toolbarTitle", static: false, private: false, access: { has: obj => "toolbarTitle" in obj, get: obj => obj.toolbarTitle, set: (obj, value) => { obj.toolbarTitle = value; } }, metadata: _metadata }, _toolbarTitle_initializers, _toolbarTitle_extraInitializers);
        __esDecorate(_classThis, null, _content_decorators, { kind: "accessor", name: "content", static: false, private: false, access: { has: obj => "content" in obj, get: obj => obj.content, set: (obj, value) => { obj.content = value; } }, metadata: _metadata }, _content_initializers, _content_extraInitializers);
        __esDecorate(_classThis, null, _actions_decorators, { kind: "accessor", name: "actions", static: false, private: false, access: { has: obj => "actions" in obj, get: obj => obj.actions, set: (obj, value) => { obj.actions = value; } }, metadata: _metadata }, _actions_initializers, _actions_extraInitializers);
        __esDecorate(_classThis, null, _toggle_decorators, { kind: "accessor", name: "toggle", static: false, private: false, access: { has: obj => "toggle" in obj, get: obj => obj.toggle, set: (obj, value) => { obj.toggle = value; } }, metadata: _metadata }, _toggle_initializers, _toggle_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsToolbar = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.CARD_COLLAPSED_EVENT = 'sds.card.collapsed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsToolbar = _classThis;
})();
export { SdsToolbar };
